// extracted by mini-css-extract-plugin
export default {"organismWrapper":"LandscapeIndicatorBaselineTemplate_organismWrapper__V1mXH"};